export default __webpack_public_path__ + "static/media/ko.2479d6d5.yaml";